import { ca } from '@cian/analytics';
import { TAnalyticsOfferStatus } from '../../../../shared/types/analytics';
import { getClientDeviceType } from '../../../../shared/utils';
import { AUTOFILL_FIELDS_MAP } from './constants';
import {
  TTrackFieldAutofilledParams,
  ITrackOfferDraftSaveFailByNoRedirectParams,
  ITrackOfferDraftSaveParams,
  ITrackPremoderationCheckParams,
  ITrackPublishFailedParams,
} from './types';

export const trackSendRosreestrRequest = (offerStatus: TAnalyticsOfferStatus) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'SendRequest',
    label: 'rosreestr_data',
  });
};

export const trackAuctionSendBid = (bet: number, product: object) => {
  ca('event', {
    name: 'oldevent',
    category: 'Auction_block',
    action: 'Send_bid',
    label: bet,
    products: [product],
  });
};

export const trackSelfEmployedEnabled = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'New_ad',
    action: 'enter_inn',
    label: 'selfemployed',
  });
};

export const trackClickOnDemandTrapBanner = (offerStatus: TAnalyticsOfferStatus) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Click',
    label: 'Banner',
    banner_location: offerStatus,
  });
};

export const trackSuccessfulMessage = (offerStatus: TAnalyticsOfferStatus) => {
  ca('event', {
    name: 'oldevent',
    category: 'Application_to_realtor',
    action: 'Send',
    label: 'Page',
    banner_location: offerStatus,
  });
};

export const trackPublishByMoneyFailed = ({ isShortForm, offerId, offerStatus }: ITrackPublishFailedParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'FailedToPublish',
    oid: offerId,
    label: 'not_enough_money',
    page: {
      pageType: 'AddForm',
      siteType: getClientDeviceType(),
      extra: {
        form_type: isShortForm ? 'short' : 'full',
      },
    },
  });
};

export const trackPublishByUnfilledFailed = ({ isShortForm, offerId, offerStatus }: ITrackPublishFailedParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'FailedToPublish',
    oid: offerId,
    label: 'requreid_field_unfilled',
    page: {
      pageType: 'AddForm',
      siteType: getClientDeviceType(),
      extra: {
        form_type: isShortForm ? 'short' : 'full',
      },
    },
  });
};

export const trackPublishByMisfilledFailed = ({ isShortForm, offerId, offerStatus }: ITrackPublishFailedParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'FailedToPublish',
    oid: offerId,
    label: 'requreid_field_misfilled',
    page: {
      pageType: 'AddForm',
      siteType: getClientDeviceType(),
      extra: {
        form_type: isShortForm ? 'short' : 'full',
      },
    },
  });
};

export const trackPremoderationCheck = ({
  isValid,
  isShortForm,
  offerStatus,
  formId,
}: ITrackPremoderationCheckParams) => {
  ca('eventSite', {
    name: 'oldevent',
    category: offerStatus,
    action: 'premoderation_check',
    label: isValid ? 'success' : 'error',
    page: {
      pageType: 'AddForm',
      siteType: getClientDeviceType(),
      extra: {
        form_type: isShortForm ? 'short' : 'full',
        form_id: formId,
      },
    },
  });
};

export const trackOfferDraftSave = ({ dealObject, offerStatus, formId }: ITrackOfferDraftSaveParams) => {
  ca('event', {
    name: 'oldevent',
    category: offerStatus,
    action: 'save_draft',
    label: dealObject,
    page: {
      pageType: 'AddForm',
      extra: {
        form_id: formId,
      },
    },
  });
};

export const trackOfferDraftSaveFailByNoRedirect = ({
  formType,
  siteType,
  offerId,
  offerStatus,
}: ITrackOfferDraftSaveFailByNoRedirectParams) => {
  ca('eventSite', {
    name: 'oldEvent',
    category: offerStatus,
    action: 'FailedToPublish',
    oid: offerId,
    label: 'no_redirect',
    page: {
      pageType: 'AddForm',
      siteType,
      extra: {
        form_type: formType,
      },
    },
  });
};

export const trackFieldsAutofilled = (fields: TTrackFieldAutofilledParams) => {
  ca('eventSite', {
    name: 'oldEvent',
    category: 'filling',
    action: 'kadastral_number',
    label: 'refilling_info',
    products: [
      {
        extra: {
          refilled_fields: fields.reduce((result, { name, isAutofilled }) => {
            const analyticFieldName = AUTOFILL_FIELDS_MAP[name];

            return analyticFieldName ? { ...result, [analyticFieldName]: Number(isAutofilled) } : result;
          }, {}),
        },
      },
    ],
  });
};
